// extracted by mini-css-extract-plugin
export default {"cls1":"VeloLabelledItem-SkeletonLabel_cls1__VZDxK","cls2":"VeloLabelledItem-SkeletonLabel_cls2__v0nP- VeloLabelledItem-SkeletonLabel_cls1__VZDxK"};